import React from "react";
import Navbar from "../components/Navbar";
import Hero from "../components/Hero";
import Services from "../components/Services";
import Partners from "../components/Partners";
import CTASection from "../components/CTASection";
import Footer from "../components/Footer";

export default function Home() {
  return (
    <div className="bg-white text-[#1a1a1a]">
      <Navbar />
      <main>
        <Hero />
        <Services />
        <Partners />
        <CTASection />
      </main>
      <Footer />
    </div>
  );
}
